import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function TabBar({ activeTab, onTabChange }) {
    const tabs = [
        { id: 'profile', label: 'PERFIL' },
        { id: 'models', label: 'MODELOS' },
        { id: 'evaluate', label: 'AVALIAR' },
        { id: 'dashboard', label: 'DASHBOARD' },
        { id: 'config', label: 'CONFIG' },
    ];
    return (_jsxs("header", { className: "brutal-header flex items-center justify-between", children: [_jsxs("h1", { className: "brutal-header-title", children: ["decidepro", _jsx("span", { className: "text-accent", children: "." })] }), _jsx("nav", { className: "brutal-tabs", children: tabs.map(tab => (_jsx("button", { onClick: () => onTabChange(tab.id), className: `brutal-tab ${activeTab === tab.id ? 'active' : ''}`, children: tab.label }, tab.id))) })] }));
}
